module.exports = __webpack_public_path__ + "static/media/Converse_hero.2525abf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Converse_hero.jpg
// module id = 482
// module chunks = 0